import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core'

import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog'
import { AssginNewGoalPageComponent } from '../assgin-new-goal-page/assgin-new-goal-page.component'
import { LeaderService } from 'src/app/leader-toolkit/services/leader.service'

@Component({
  selector: 'app-assign-goals-modal',
  standalone: false,
  templateUrl: './assign-goals-modal.html',
  styleUrls: ['./assign-goals-modal.scss'],
})
export class AssignGoalsModalComponent implements OnInit {


  hospitalList: any[] = [];
  selectedHospital: any = ""
  uniqueHospitals: any
  filteredHospitals: any[] = [];
  quarterList: any
  selectedQuarter: any
  showAutoComplete: boolean = false;
  selectedHospitalObj: any;
  selectedQuarterObj: any;

  constructor(
    private dialog: MatDialog,
    public leaderService: LeaderService,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<AssignGoalsModalComponent>
  ) { }

  ngOnInit(): void {
    this.uniqueHospitals = this.data.uniqueHospitals;
    this.filteredHospitals = this.uniqueHospitals || [];
    this.quarterList = this.data.quarterList;
  }

  onHospitalChange(searchValue: string) {
    const normalizedSearch = (searchValue || '').toLowerCase();
    if (!normalizedSearch.trim()) {
      this.filteredHospitals = this.uniqueHospitals || [];
      return;
    }
    this.filteredHospitals = (this.uniqueHospitals || []).filter((hospital: any) =>
      (hospital?.practiceName || '').toString().toLowerCase().includes(normalizedSearch)
    );
  }

  findHospitalIdandQuarterId() {
    this.selectedHospitalObj = this.uniqueHospitals.find((h: any) => h.practiceName === this.selectedHospital);
    this.selectedQuarterObj = this.quarterList.find((q: any) => q.quarterName === this.selectedQuarter);
  }

  onClose() {
    this.dialogRef.close();
  }

  newAssginGoalPage() {
    this.findHospitalIdandQuarterId();
    const dialogRef = this.dialog.open(AssginNewGoalPageComponent, {
      data: { hospital: this.selectedHospitalObj, quarter: this.selectedQuarterObj },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(result => {
       this.dialogRef.close('success');
    });
  }

  showAuto() {
    this.showAutoComplete = !this.showAutoComplete;
  }

  resetAllValues() {
    this.selectedHospital = '';
    this.selectedQuarter = '';
    this.selectedHospitalObj = null;
    this.selectedQuarterObj = null;
    this.filteredHospitals = this.uniqueHospitals || [];
  }
}